import { polygonRingFromImgPosCoords } from '@/services/defect/defectMapIrAlignment';
import imageCoordinateCalculator from '@/utils/imageCoordinateCalculator';
import { imageCornersFromRingOrder } from '@/features/defect-drawer/utils/resolveModuleCoveringIrImages';

export function openRing(ring) {
  if (!Array.isArray(ring) || ring.length < 3) {
    return null;
  }
  const first = ring[0];
  const last = ring[ring.length - 1];
  const open =
    first &&
    last &&
    Number(first[0]) === Number(last[0]) &&
    Number(first[1]) === Number(last[1])
      ? ring.slice(0, -1)
      : ring;
  return open.length >= 3 ? open : null;
}

export function aabbFromQuad(quad) {
  if (!Array.isArray(quad) || quad.length < 3) {
    return null;
  }
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const pt of quad) {
    const x = Number(pt?.[0]);
    const y = Number(pt?.[1]);
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
      continue;
    }
    if (x < minX) minX = x;
    if (y < minY) minY = y;
    if (x > maxX) maxX = x;
    if (y > maxY) maxY = y;
  }
  const width = maxX - minX;
  const height = maxY - minY;
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }
  return { x: minX, y: minY, width, height };
}

export function projectModuleRingToIrQuad(moduleRing, image) {
  const pts = openRing(moduleRing);
  const irRing = polygonRingFromImgPosCoords(image?.imgPosCoords);
  const corners = imageCornersFromRingOrder(irRing);
  if (!pts || !irRing || !corners) {
    return null;
  }
  const width = Math.max(1, Number(image?.imgWidth) || 640);
  const height = Math.max(1, Number(image?.imgHeight) || 512);
  const quad = [];
  for (const pt of pts) {
    const px = imageCoordinateCalculator.geographicToPixel(
      { width, height },
      Number(pt[0]),
      Number(pt[1]),
      irRing,
      corners
    );
    if (!px || !Number.isFinite(px.pixelX) || !Number.isFinite(px.pixelY)) {
      return null;
    }
    quad.push([px.pixelX, px.pixelY]);
  }
  const aabb = aabbFromQuad(quad);
  if (!aabb) {
    return null;
  }
  return { quad, aabb };
}
